import { api, getCurrentUser } from '@creditsights/api-ui-web';
import { Preference } from '../../models/Preference';
import { PROFILES_MODULE_V1_URI } from '../services.constants';

const InterestsUri = (userId: string) => `${PROFILES_MODULE_V1_URI}${userId}/interests`;

export const fetchMyContentPreferences = async (): Promise<Preference[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return [];
  }

  const { data } = await api.get<{ subscriptions: Preference[] }>(InterestsUri(userId));
  return data?.subscriptions || [];
};

export const updateMyContentPreferences = async (preferences: Preference[]): Promise<Preference[]> => {
  const { userId } = getCurrentUser();
  if (!userId) {
    return [];
  }

  const { data } = await api.patch<{ subscriptions: Preference[] }>(InterestsUri(userId), {
    subscriptions: preferences,
  });
  return data?.subscriptions || [];
};
